export default __webpack_public_path__ + "static/media/hht2_sitcom_03.8385e869.png";